import { ApiQueryBuilder } from "@/hooks/use-api-query";
import { QueryKey } from "@/utils/query-key";

interface Input {
    invitationId?: string
}

interface Output {
    challenge: string
    credentialId: string
}

export const GetTenantUserChallenge: ApiQueryBuilder<Output, Input, [string | undefined]> = ({ invitationId } = {}) => ({
    queryKey: [QueryKey.TenantUserChallenge, invitationId],
    queryFn: async (apiClient) => {
        const searchParams = new URLSearchParams()
        if (invitationId) {
            searchParams.set('invitation-id', invitationId)
        }
        const searchParamsString = searchParams.toString()
        const response = await apiClient.get<Output>(`/tenants/auth/challenge?${searchParamsString}`)
        return response.data
    }
})